import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../useTheme"; // 👈 importe le hook
import "../login.css";

const API_URL = "https://2504.ict-expert.ch/api";

// 🔐 REGEX POUR LA VALIDATION CÔTÉ CLIENT
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Minimum 8 caractères, au moins une lettre majuscule, une lettre minuscule et un chiffre
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;


function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  // NOUVEAU: États pour les messages d'erreur spécifiques à la validation
  const [emailError, setEmailError] = useState(null);
  const [passwordError, setPasswordError] = useState(null);

  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme(); // 👈

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  // Fonction centrale de validation (utilisée par le login et le register)
  function validateInputs() {
    let isValid = true;
    setEmailError(null);
    setPasswordError(null);

    if (!EMAIL_REGEX.test(email)) {
      setEmailError("Email invalide.");
      isValid = false;
    }

    if (!PASSWORD_REGEX.test(password)) {
      setPasswordError(
        "Min. 8 caractères, incluant majuscule, minuscule et chiffre."
      );
      isValid = false;
    }

    return isValid;
  }
  
  // Fonction pour appeler l'API après validation
  async function callAuth(endpoint) {
    setLoading(true);
    setMessage(null);

    try {
      const res = await fetch(`${API_URL}/${endpoint}.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Erreur inconnue");

      localStorage.setItem("token", data.token);
      localStorage.setItem("userEmail", data.user.email);

      navigate("/", { replace: true });
    } catch (err) {
      setMessage(err.message);
    } finally {
      setLoading(false);
    }
  }

  function handleAuthAttempt(e, endpoint) {
    e.preventDefault();
    if (!validateInputs()) {
      return; // Stop si la validation échoue
    }
    callAuth(endpoint);
  }

  function handleRegister(e) {
    handleAuthAttempt(e, "register");
  }

  function handleLogin(e) {
    handleAuthAttempt(e, "login");
  }

  // Fonction pour effacer les messages d'erreur lors de la saisie
  function handleEmailChange(e) {
    setEmail(e.target.value);
    setEmailError(null); // Clear error on change
  }

  function handlePasswordChange(e) {
    setPassword(e.target.value);
    setPasswordError(null); // Clear error on change
  }
  
  return (
    <div className="login-root">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo-dot" />
          <div>
            <h1 className="login-title">TaskList</h1>
            <p className="login-subtitle">
              Connecte-toi pour gérer tes tâches.
            </p>
          </div>
          <button
            type="button"
            className="theme-toggle-btn"
            onClick={toggleTheme}
          >
            {theme === "light" ? "🌙" : "☀️"}
          </button>
        </div>

        <form className="login-form" onSubmit={(e) => e.preventDefault()}>
          {/* Email Field */}
          <label className="login-field">
            <span>Email</span>
            <input
              className={`login-input ${emailError ? 'input-error' : ''}`}
              type="email"
              placeholder="ton.email@exemple.ch"
              value={email}
              onChange={handleEmailChange} // Utiliser la nouvelle fonction
              required
            />
            {emailError && <p className="validation-error">{emailError}</p>}
          </label>

          {/* Password Field */}
          <label className="login-field">
            <span>Mot de passe</span>
            <input
              className={`login-input ${passwordError ? 'input-error' : ''}`}
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={handlePasswordChange} // Utiliser la nouvelle fonction
              required
            />
            {passwordError && <p className="validation-error">{passwordError}</p>}
          </label>

          {message && <p className="login-message">{message}</p>}

          <div className="login-actions">
            <button
              className="login-btn login-btn-secondary"
              onClick={handleRegister}
              disabled={loading}
              type="button"
            >
              {loading ? "..." : "S'inscrire"}
            </button>
            <button
              className="login-btn login-btn-primary"
              onClick={handleLogin}
              disabled={loading}
              type="button"
            >
              {loading ? "..." : "Se connecter"}
            </button>
          </div>

          <p className="login-hint">
            Ton compte sera créé automatiquement si tu t&apos;inscris.
          </p>
        </form>
      </div>
    </div>
  );
}

export default Login;